const translation = {
  pageTitle: 'Ehi, iniziamo!👋',
  welcome: 'Benvenuto su Dify, per favore accedi per continuare.',
  email: 'Indirizzo email',
  emailPlaceholder: 'La tua email',
  password: 'Password',
  passwordPlaceholder: 'La tua password',
  name: 'Nome utente',
  namePlaceholder: 'Il tuo nome utente',
  forget: 'Hai dimenticato la password?',
  signBtn: 'Accedi',
  sso: 'Continua con SSO',
  installBtn: 'Configura',
  setAdminAccount: 'Impostazione di un account amministratore',
  setAdminAccountDesc:
    'Privilegi massimi per l\'account amministratore, che può essere utilizzato per creare applicazioni e gestire i fornitori di LLM, ecc.',
  createAndSignIn: 'Crea e accedi',
  oneMoreStep: 'Un altro passo',
  createSample:
    'In base a queste informazioni, creeremo un\'applicazione di esempio per te',
  invitationCode: 'Codice di invito',
  invitationCodePlaceholder: 'Il tuo codice di invito',
  interfaceLanguage: 'Lingua dell\'interfaccia',
  timezone: 'Fuso orario',
  go: 'Vai a Dify',
  sendUsMail:
    'Inviaci una email con la tua presentazione e gestiremo la richiesta di invito.',
  acceptPP: 'Ho letto e accetto l\'informativa sulla privacy',
  reset:
    'Per favore esegui il seguente comando per reimpostare la tua password',
  withGitHub: 'Continua con GitHub',
  withGoogle: 'Continua con Google',
  rightTitle: 'Sblocca tutto il potenziale di LLM',
  rightDesc:
    'Costruisci senza sforzo applicazioni AI visivamente accattivanti, operabili e migliorabili.',
  tos: 'Termini di servizio',
  pp: 'Informativa sulla privacy',
  tosDesc: 'Iscrivendoti, accetti i nostri',
  goToInit:
    'Se non hai inizializzato l\'account, vai alla pagina di inizializzazione',
  dontHave: 'Non hai?',
  invalidInvitationCode: 'Codice di invito non valido',
  accountAlreadyInited: 'Account già inizializzato',
  forgotPassword: 'Hai dimenticato la password?',
  resetLinkSent: 'Link per il reset inviato',
  sendResetLink: 'Invia link per il reset',
  backToSignIn: 'Torna al login',
  forgotPasswordDesc:
    'Per favore inserisci il tuo indirizzo email per reimpostare la tua password. Ti invieremo una email con le istruzioni su come reimpostare la tua password.',
  checkEmailForResetLink:
    'Per favore controlla la tua email per un link per reimpostare la password. Se non compare entro pochi minuti, assicurati di controllare la cartella spam.',
  passwordChanged: 'Accedi ora',
  changePassword: 'Cambia Password',
  changePasswordTip:
    'Per favore inserisci una nuova password per il tuo account',
  invalidToken: 'Token non valido o scaduto',
  confirmPassword: 'Conferma Password',
  confirmPasswordPlaceholder: 'Conferma la tua nuova password',
  passwordChangedTip: 'La tua password è stata cambiata con successo',
  error: {
    emailEmpty: 'L\'indirizzo email è obbligatorio',
    emailInValid: 'Per favore inserisci un indirizzo email valido',
    nameEmpty: 'Il nome è obbligatorio',
    passwordEmpty: 'La password è obbligatoria',
    passwordLengthInValid: 'La password deve essere di almeno 8 caratteri',
    passwordInvalid:
      'La password deve contenere lettere e numeri, e la lunghezza deve essere maggiore di 8',
    registrationNotAllowed: 'Account non trovato. Si prega di contattare l\'amministratore di sistema per registrarsi.',
  },
  license: {
    tip: 'Prima di avviare Dify Community Edition, leggi su GitHub',
    link: 'Licenza open-source',
  },
  join: 'Unisciti',
  joinTipStart: 'Invitato a unirti al',
  joinTipEnd: 'team su Dify',
  invalid: 'Il link è scaduto',
  explore: 'Esplora Dify',
  activatedTipStart: 'Sei entrato nel team',
  activatedTipEnd: '',
  activated: 'Accedi ora',
  adminInitPassword: 'Password di inizializzazione amministratore',
  validate: 'Convalida',
  checkCode: {
    invalidCode: 'Codice non valido',
    verificationCodePlaceholder: 'Inserisci il codice a 6 cifre',
    verify: 'Verificare',
    emptyCode: 'Il codice è obbligatorio',
    resend: 'Inviare',
    verificationCode: 'Codice di verifica',
    validTime: 'Tieni presente che il codice è valido per 5 minuti',
    didNotReceiveCode: 'Non hai ricevuto il codice?',
    checkYourEmail: 'Controlla la tua email',
    tips: 'Inviamo un codice di verifica a <strong>{{email}}</strong>',
    useAnotherMethod: 'Usa un altro metodo',
  },
  or: 'O',
  back: 'Indietro',
  noLoginMethod: 'Metodo di autenticazione non configurato',
  backToLogin: 'Torna al login',
  changePasswordBtn: 'Imposta una password',
  setYourAccount: 'Imposta il tuo account',
  withSSO: 'Continua con SSO',
  usePassword: 'Usa password',
  resetPassword: 'Reimposta password',
  continueWithCode: 'Continua con il codice',
  sendVerificationCode: 'Invia codice di verifica',
  useVerificationCode: 'Usa il codice di verifica',
  resetPasswordDesc: 'Digita l\'e-mail che hai utilizzato per registrarti su Dify e ti invieremo un\'e-mail per reimpostare la password.',
  noLoginMethodTip: 'Contatta l\'amministratore di sistema per aggiungere un metodo di autenticazione.',
  enterYourName: 'Inserisci il tuo nome utente',
  licenseLostTip: 'Impossibile connettersi al server licenze Dify. Contatta il tuo amministratore per continuare a utilizzare Dify.',
  licenseExpired: 'Licenza scaduta',
  licenseLost: 'Licenza persa',
  licenseExpiredTip: 'La licenza Dify Enterprise per la tua area di lavoro è scaduta. Contatta il tuo amministratore per continuare a utilizzare Dify.',
  licenseInactiveTip: 'La licenza Dify Enterprise per la tua area di lavoro è inattiva. Contatta il tuo amministratore per continuare a utilizzare Dify.',
  licenseInactive: 'Licenza inattiva',
  webapp: {
    noLoginMethod: 'Metodo di autenticazione non configurato per l\'app web',
    noLoginMethodTip: 'Si prega di contattare l\'amministratore del sistema per aggiungere un metodo di autenticazione.',
    disabled: 'L\'autenticazione dell\'app web è disabilitata. Si prega di contattare l\'amministratore di sistema per abilitarla. Puoi provare a utilizzare l\'app direttamente.',
  },
}

export default translation
